<template>
  <main class="login-page">
    <div class="login-overlay" aria-hidden="true"></div>

    <div class="login-shell">
      <div class="login-panel">
        <div class="login-brand text-center">
          <img src="/assets/Logo.png" alt="Mi Stock" class="login-logo" />
          <p class="login-tagline">Controla, gestiona, crece.</p>
        </div>

        <form class="login-form" role="form" @submit.prevent="handleLogin">
          <div class="mb-3">
            <label for="login-email" class="login-label">Email</label>
            <argon-input
              id="login-email"
              v-model="user.email"
              type="email"
              class="mb-0 login-input"
              placeholder="correo@empresa.com"
              name="email"
              size="lg"
            />
            <validation-error :errors="apiValidationErrors.email" />
          </div>

          <div class="mb-3">
            <label for="login-password" class="login-label">Contraseña</label>
            <argon-input
              id="login-password"
              v-model="user.password"
              type="password"
              class="mb-0 login-input"
              placeholder="Ingresa tu contraseña"
              name="password"
              size="lg"
            />
          </div>

          <div class="d-flex align-items-center mb-4">
            <argon-switch id="rememberMe">Recuérdame</argon-switch>
          </div>

          <argon-button
            type="submit"
            class="login-submit w-100"
            color="primary"
            fullWidth
            size="lg"
          >
            Iniciar sesión
          </argon-button>

          <div class="text-center mt-4">
            <router-link :to="{ name: 'Forgot Password' }" class="login-forgot">
              ¿Olvidaste tu contraseña?
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import formMixin from "../../mixins/form-mixin.js";
import ValidationError from "../../components/ValidationError.vue";
import showSwal from "../../mixins/showSwal.js";
import Swal from "sweetalert2";

export default {
  name: "Login",
  components: {
    ArgonInput,
    ArgonSwitch,
    ArgonButton,
    ValidationError,
  },
  mixins: [formMixin, showSwal],
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
    };
  },
  created() {
    this.$store.commit("applyRouteLayout", { meta: { layout: "auth" } });
  },
  methods: {
    async handleLogin() {
      try {
        this.resetApiValidation();
        await this.$store.dispatch("auth/login", this.user);
        window.location.href = this.$router.resolve({ name: "Dashboard" }).href;
      } catch (error) {
        const status = error?.response?.status;
        let text = "Credenciales incorrectas. Verifica tu email y contraseña.";
        if (status === 403) {
          text = error?.response?.data?.message
            || "Su usuario no tiene permiso para acceder al panel.";
        } else if (status === 401) {
          text = "Email o contraseña incorrectos.";
        }
        await Swal.fire({
          icon: "error",
          title: "Acceso denegado",
          text,
        });
        if (error?.response?.data?.errors) {
          this.setApiValidation(error.response.data.errors);
        }
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  background: #0f1628 url("/assets/fondo_login.png") center center / cover no-repeat;
  overflow: hidden;
}

.login-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    105deg,
    rgba(8, 14, 28, 0.92) 0%,
    rgba(8, 14, 28, 0.72) 38%,
    rgba(8, 14, 28, 0.28) 68%,
    rgba(8, 14, 28, 0.12) 100%
  );
}

.login-shell {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2rem clamp(1.25rem, 4vw, 4rem);
}

.login-panel {
  width: 100%;
  max-width: 430px;
  padding: 2.25rem 2rem 2rem;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow:
    0 28px 70px rgba(0, 0, 0, 0.35),
    0 0 0 1px rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
}

.login-brand {
  margin-bottom: 1.75rem;
}

.login-logo {
  max-height: 72px;
  width: auto;
  object-fit: contain;
}

.login-tagline {
  margin: 0.75rem 0 0;
  font-size: 0.85rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6c757d;
  font-weight: 600;
}

.login-label {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #344767;
}

.login-forgot {
  color: #2c3a59;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}

.login-forgot:hover {
  color: #c99700;
}

.login-submit :deep(.btn) {
  background: linear-gradient(135deg, #d4a017 0%, #f0c419 55%, #c99700 100%) !important;
  border: none !important;
  color: #1a233a !important;
  font-weight: 700;
  letter-spacing: 0.02em;
  border-radius: 12px !important;
  padding: 0.85rem 1rem !important;
  box-shadow: 0 10px 24px rgba(212, 160, 23, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.login-submit :deep(.btn:hover) {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(212, 160, 23, 0.42);
  color: #1a233a !important;
}

.login-input :deep(.form-control) {
  border: 1px solid #d2d6da;
  border-radius: 12px;
  min-height: 46px;
  padding: 0.65rem 0.9rem;
  font-size: 0.95rem;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.login-input :deep(.form-control:focus) {
  border-color: #c99700;
  box-shadow: 0 0 0 0.2rem rgba(201, 151, 0, 0.15);
}

.login-input :deep(.input-group-text) {
  border-radius: 0 12px 12px 0;
  border-color: #d2d6da;
  background: #f8f9fa;
}

.login-form :deep(.form-check-input:checked) {
  background-color: #c99700;
  border-color: #c99700;
}

@media (max-width: 991.98px) {
  .login-overlay {
    background: rgba(8, 14, 28, 0.82);
  }

  .login-shell {
    justify-content: center;
    padding: 1.5rem;
  }

  .login-panel {
    max-width: 460px;
  }
}

@media (max-width: 575.98px) {
  .login-panel {
    padding: 1.75rem 1.25rem 1.5rem;
    border-radius: 18px;
  }

  .login-logo {
    max-height: 60px;
  }
}
</style>
